module.exports = __webpack_public_path__ + "fonts/inter-latin-500-normal.woff2";